import React, { useEffect } from 'react';
import { useLocationCtx } from '../context/LocationContext';

export default function LocationSwitcher({ portalRoles }) {
  const ctx = useLocationCtx();
  const { locations = [], allAccess = false, currentLocationId, setCurrentLocation } = ctx || {};
  const visible = allAccess ? locations : locations.filter((l) => !portalRoles || (l.roles || []).some((r) => portalRoles.includes(r)));
  useEffect(() => {
    if (visible.length && !visible.some((l) => l.id === currentLocationId)) setCurrentLocation(visible[0].id);
  }, [visible.map((l) => l.id).join(','), currentLocationId]);
  if (!ctx || visible.length <= 1) return null;
  return (
    <div style={{ padding: '10px 12px' }}>
      <div style={{ fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', opacity: 0.6, marginBottom: 4 }}>Location</div>
      <select value={currentLocationId || ''} onChange={(e) => setCurrentLocation(e.target.value)}
        style={{ width: '100%', background: 'rgba(255,255,255,.08)', color: '#fff', border: '1px solid rgba(255,255,255,.2)', borderRadius: 8, padding: '7px 10px', fontSize: 12.5 }}>
        {visible.map((l) => <option key={l.id} value={l.id} style={{ color: '#111' }}>{l.name}</option>)}
      </select>
    </div>
  );
}
